import Api from "./base/api-base";

export default class BudgetApi {
  info (construction_id, budget_id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.construction, id: construction_id},
        {endpoint: Api.endpoint.budget, id: budget_id}
      ]
    });
  }

  store (construction_id, params) {
    return Api.link.post({
      links: [
        {endpoint: Api.endpoint.construction, id: construction_id},
        {endpoint: Api.endpoint.budget}
      ],
      params: params
    });
  }

  update (construction_id, budget_id, params) {
    return Api.link.post({
      links: [
        {endpoint: Api.endpoint.construction, id: construction_id},
        {endpoint: Api.endpoint.budget, id: budget_id}
      ],
      params: params
    });
  }
}